// Types
import { FeatureFlagUtilsType } from './types/feature-flag.utils.type';
import { FeatureFlagType } from 'types/feature-flag.type';

const isFeatureFlagLoadedAndIsNotVisible = ({ featureFlags, id }: FeatureFlagUtilsType): boolean =>
  featureFlags?.length > 0 &&
  featureFlags?.some((flag: FeatureFlagType) => flag.flagName === id && !flag.isEnabled);

export { isFeatureFlagLoadedAndIsNotVisible };
